// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  instagram_token: 'INSTAGRAM_TOKEN',
  stripe_token: 'STRIPE_PUBLISHABLE_KEY',
  paypal_token: 'PAYPAL_CLIENT_ID',
  // url_api_user : 'https://rajanti-api-user.komunestudio.com/api/',
  // url_api_neo : 'https://rajanti-api-neo.komunestudio.com/v1/',
  // url_api_diagnosis : 'https://rajanti-api-diagnosis.komunestudio.com/',

  // url_api_user : 'https://temp-api.klinikhewanrajanti.com/user-api/api/',
  // url_api_neo : 'https://temp-api.klinikhewanrajanti.com/intellivent-api/v1/',
  // url_api_diagnosis : 'https://temp-api.klinikhewanrajanti.com/diagnosis-api/',

  url_api_user : 'https://neo-api.klinikhewanrajanti.com/user/api/',
  url_api_neo : 'https://neo-api.klinikhewanrajanti.com/neo/v1/',
  url_api_diagnosis : 'https://neo-api.klinikhewanrajanti.com/diagnosis/'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
